import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { fontScalings } from "../constants/BaseConstants";

interface FontScalingMenuProps {
  anchor: HTMLElement | null; // allow null (closed)
  selectedFontScaling: number;
  handleFontScalingChange: (value: number) => void;
  handleMenuClose: () => void;
}

const titleStyle = {
  padding: "10px 0px 5px 15px",
  fontWeight: "bold",
  fontSize: "16px",
  width: "125px",
} as const;

function FontScalingMenuImpl(props: FontScalingMenuProps): JSX.Element {
  const { anchor, selectedFontScaling, handleFontScalingChange, handleMenuClose } = props;
  const open = Boolean(anchor);

  // Slightly reduces prop churn in MenuItems
  const onPick = React.useCallback(
    (value: number) => {
      handleFontScalingChange(value);
    },
    [handleFontScalingChange],
  );

  return (
    <Menu
      anchorEl={anchor}
      open={open}
      onClose={handleMenuClose}
      aria-label="Font size menu"
      keepMounted                 // avoid mount cost on each open
      transitionDuration={0}      // no grow/fade animation -> quicker paint
    >
      <Typography sx={titleStyle}>Text Size</Typography>
      {fontScalings.map((item) => (
        <MenuItem
          value={item}
          key={`font-scaling-${item}`}
          selected={item === selectedFontScaling}
          onClick={() => onPick(item)}
        >
          {item}%
        </MenuItem>
      ))}
      <Box m={1} />
    </Menu>
  );
}

// Skip re-renders unless inputs change
export default React.memo(FontScalingMenuImpl, (a, b) =>
  a.anchor === b.anchor &&
  a.selectedFontScaling === b.selectedFontScaling &&
  a.handleFontScalingChange === b.handleFontScalingChange &&
  a.handleMenuClose === b.handleMenuClose
);
